import TotalStatistics from './TotalStatistics';

export default TotalStatistics;
